/* eslint-disable import/first */
import 'babel-polyfill';


/*
* Style imports
 */
import 'bootstrap/dist/css/bootstrap.css';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-table/react-table.css';
import './index.css';

/*
* Library imports
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

/*
* Project imports
 */
import App from './components/App';
import configureStore from './store';
import configureLink from './link';
import configureAxios from './axios';
import configureHistory from './history';
import configureAnalytics from './analytics';
import registerServiceWorker from './registerServiceWorker';
import { loadConfiguration } from './features/configuration/actions';
import { loadAuthentication } from './features/authentication/actions';


const startApplication = async () => {
  const thunkExtraArgument = { client: null, axios: null, history: null };
  const store = configureStore(thunkExtraArgument);
  await store.dispatch(loadConfiguration('/config.json'));
  await store.dispatch(loadAuthentication());

  const link = configureLink(store);
  const cache = new InMemoryCache();

  const defaultOptions = {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  };

  const client = new ApolloClient({ link, cache, defaultOptions });
  thunkExtraArgument.client = client;

  const axios = configureAxios(store);
  thunkExtraArgument.axios = axios;

  const analyticsTracker = configureAnalytics(store);
  const history = configureHistory(analyticsTracker);
  thunkExtraArgument.history = history;

  ReactDOM.render(
    <ApolloProvider client={client}>
      <Provider store={store}>
        <Router history={history}>
          <App />
        </Router>
      </Provider>
    </ApolloProvider>,
    document.getElementById('root'),
  );
};

startApplication();
registerServiceWorker();
